import React, { useContext, useState } from "react";
import DetailLayout from "../components/DetailLayout";
import VoteHeader from "./components/VoteHeader";
import { RouteComponentProps } from "react-router-dom";
import useRequest from "utils/useRequest";
import { Spin } from "antd";
import { getCoursewareLearnStatus } from "../../../service/CourseDetail/resource";
import { CourseContext } from "../Store";
import useCurrentDate from "../../../utils/useCurrentDate";
import { toNumber } from "../../../service/service";
import VoteStuTable from "./components/VoteStuTable";
import useQuery from "../../../utils/useQuery";

interface VoteDetailProps {
    sourceId: string;
}

export default function ResourceStatistics({
    match
}: RouteComponentProps<VoteDetailProps>) {
    const { sourceId } = match.params;
    const { course } = useContext(CourseContext);
    const { batchNo } = useCurrentDate();

    const { status } = useQuery<{ status: string }>();
    const [searchText, setSearchText] = useState("");
    const [filterStatus, setFilterStatus] = useState(status || "");

    const [data, { loading }, refreshData] = useRequest(
        () =>
            getCoursewareLearnStatus({
                studyStatusEntity: {
                    studyStatus: filterStatus
                },
                keyword: searchText,
                batchNo,
                courseNo: course.courseNo,
                courseSeq: course.courseSeq,
                weektimeId: course.weekTimeId,
                id: toNumber(sourceId)
            }),
        {},
        [sourceId, filterStatus, searchText]
    );

    function refreshAll() {
        refreshData();
    }

    return (
        <DetailLayout breadcrumb="学习详情">
            <Spin spinning={loading}>
                <VoteHeader data={data} />
                <VoteStuTable
                    searchText={searchText}
                    setSearchText={setSearchText}
                    filterStatus={filterStatus}
                    setFilterStatus={setFilterStatus}
                    data={data}
                />
            </Spin>
        </DetailLayout>
    );
}
